import type {RGBA} from '@Utils/color.util';
import {LineCapStyle, LineDashType} from '@PosterWhiteboard/items/line-item/line-item.types';

const FILL_COLOR: RGBA = [0, 0, 0, 1];
interface PMWShapeToLineMap {
  fillColor: RGBA;
  lineDashType: LineDashType;
  lineCapStart: LineCapStyle;
  lineCapEnd: LineCapStyle;
}

export const PMW_SHAPE_TO_LINE_HASHMAP: Record<string, PMWShapeToLineMap> = {
  '1240': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.NONE,
    lineCapEnd: LineCapStyle.NONE,
  },
  '1243': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.NONE,
    lineCapEnd: LineCapStyle.ARROW,
  },
  '1244': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.DASH,
    lineCapStart: LineCapStyle.NONE,
    lineCapEnd: LineCapStyle.NONE,
  },
  '1245': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.LONG_DASH,
    lineCapStart: LineCapStyle.NONE,
    lineCapEnd: LineCapStyle.NONE,
  },
  '1246': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.ARROW,
    lineCapEnd: LineCapStyle.ARROW,
  },
  '1247': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.DASH,
    lineCapStart: LineCapStyle.NONE,
    lineCapEnd: LineCapStyle.ARROW,
  },
  '1248': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.DASH,
    lineCapStart: LineCapStyle.FILLED_ARROW,
    lineCapEnd: LineCapStyle.FILLED_ARROW,
  },
  '1249': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.FILLED_CIRCLE,
    lineCapEnd: LineCapStyle.FILLED_CIRCLE,
  },
  '1250': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.DASH,
    lineCapStart: LineCapStyle.FILLED_CIRCLE,
    lineCapEnd: LineCapStyle.FILLED_CIRCLE,
  },
  '1251': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.CIRCLE,
    lineCapEnd: LineCapStyle.CIRCLE,
  },
  '1252': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.DIAMOND,
    lineCapEnd: LineCapStyle.DIAMOND,
  },
  '1253': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.FILLED_DIAMOND,
    lineCapEnd: LineCapStyle.FILLED_DIAMOND,
  },
  '1254': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.NONE,
    lineCapStart: LineCapStyle.SQUARE,
    lineCapEnd: LineCapStyle.SQUARE,
  },
  '1255': {
    fillColor: FILL_COLOR,
    lineDashType: LineDashType.DASH,
    lineCapStart: LineCapStyle.FILLED_SQUARE,
    lineCapEnd: LineCapStyle.FILLED_SQUARE,
  },
};
